import { ArrowLeft, ArrowLeft2, ArrowRight2, Category, Save2 } from "iconsax-react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import work_times from "../../../utils/work_time";
import isEqual from "lodash.isequal";
import storageNames from "../../../utils/storage_names";


// Monday
export function Monday({ currentDay }) {

    const monday_data = window.localStorage.getItem(storageNames.MONDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!monday_data ? [] : JSON.parse(monday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.MONDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])


    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Tuesday
export function Tuesday({ currentDay, onDaySaved }) {

    const tuesday_data = window.localStorage.getItem(storageNames.TUESDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!tuesday_data ? [] : JSON.parse(tuesday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(tuesday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.TUESDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])



    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Wednesday
export function Wednesday({ currentDay, onDaySaved }) {

   const wednesday_data = window.localStorage.getItem(storageNames.WEDNESDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!wednesday_data ? [] : JSON.parse(wednesday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.WEDNESDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Thursday
export function Thursday({ currentDay, onDaySaved }) {

   const thursday_data = window.localStorage.getItem(storageNames.THURSDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!thursday_data ? [] : JSON.parse(thursday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.THURSDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Friday
export function Friday({ currentDay, onDaySaved }) {

   const friday_data = window.localStorage.getItem(storageNames.FRIDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!friday_data ? [] : JSON.parse(friday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.FRIDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Saturday
export function Saturday({ currentDay, onDaySaved }) {

   const saturday_data = window.localStorage.getItem(storageNames.SATURDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!saturday_data ? [] : JSON.parse(saturday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.SATURDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}

// Sunday
export function Sunday({ currentDay, onDaySaved }) {

   const sunday_data = window.localStorage.getItem(storageNames.SUNDAY_DATA)

    const [availableTimes, setAvailableTimes] = useState(!sunday_data ? [] : JSON.parse(sunday_data))

    function handleSettingTime(time) {
        if (availableTimes.some(t => isEqual(t, time))) {
            // remove the time from availableTimes
            setAvailableTimes(availableTimes.filter(t => !isEqual(t, time)));
        } else {
            // add the time to availableTimes
            setAvailableTimes([...availableTimes, time]);
        }
    }

    function handleAllTime() {
        setAvailableTimes(work_times)
    }

    function handleClear() {
        setAvailableTimes([])
    }


    // useEffect(() => {
    //     console.log(availableTimes);
        
    //     console.log(monday_data);
        
    // }, [currentDay])

    useEffect(() => {
        window.localStorage.setItem(storageNames.SUNDAY_DATA, JSON.stringify(availableTimes));
    }, [availableTimes])

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-10 gap-4 items-center whitespace-nowrap ">
                {
                    work_times.map(time => (
                        <button onClick={() => handleSettingTime(time)} className={`${availableTimes?.some(t => isEqual(t, time))  ? "bg-[#00b0ad22] text-[#00b0ad] border-[#00b0ad] font-medium" : "border-gray-500 text-gray-500"} text-[14px] col-span-2 p-2 flex justify-center items-center cursor-pointer border rounded-[4px]`} key={time.time_id}>
                            {time.time}
                        </button>
                    ))
                }
            </div>

            <div className="flex gap-3 items-center">
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad] text-white items-center rounded-[4px] font-medium" onClick={handleAllTime}>
                    <Category size={16} variant="Bold" />
                    Select all
                </button>
                <button className="flex gap-2 px-6 py-[6px] text-[14px] border border-[#00b0ad] bg-[#00b0ad22] text-[#00b0ad] items-center rounded-[4px] font-medium" onClick={handleClear}>
                    <X size={16} color="#00b0ad" />
                    Clear all
                </button>
            </div>
            
        </div>
    )
}